import { storage } from '@/shared/utils/storage';

const STORAGE_KEY = 'device_id';

export function getOrCreateDeviceId(): string {
  const stored = storage.get(STORAGE_KEY);
  if (stored) return stored;

  const id = crypto.randomUUID();
  storage.set(STORAGE_KEY, id);
  return id;
}

async function importPublicKey(pem: string): Promise<CryptoKey> {
  const base64 = pem
    .replace(/-----BEGIN PUBLIC KEY-----/, '')
    .replace(/-----END PUBLIC KEY-----/, '')
    .replace(/\\n/g, '')
    .replace(/\s+/g, '');

  const binaryDer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

  return crypto.subtle.importKey(
    'spki',
    binaryDer.buffer,
    { name: 'RSA-OAEP', hash: 'SHA-1' },
    false,
    ['encrypt']
  );
}

async function encryptToBase64(
  publicKey: CryptoKey,
  plaintext: string
): Promise<string> {
  const encoded = new TextEncoder().encode(plaintext);
  const encrypted = await crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    publicKey,
    encoded
  );
  return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}

let _deviceIdHeader: string | null = null;

export async function initDeviceId(): Promise<void> {
  const pem = window.__CONFIG__?.deviceIdPublicKey;

  if (!pem) {
    console.warn('[deviceId] не задан deviceIdPublicKey');
    return;
  }

  const deviceId = getOrCreateDeviceId();
  const plaintext = `${deviceId},`;

  const publicKey = await importPublicKey(pem);
  _deviceIdHeader = await encryptToBase64(publicKey, plaintext);
}

export function getDeviceIdHeader(): string | null {
  return _deviceIdHeader;
}
